import languageLocaleUtils from 'utils/LanguageLocale';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import UserUtils from 'utils/User';
import Empty from 'constants/empty';

const US_ZIP_CODE_FORMAT = /\d{5}(?:[-\s]\d{4})?$/;

const { COUNTRIES } = languageLocaleUtils;

// Do not use this method on billing addresses since AVS shoutd not be enabled on billing addresses
function hasAVS(country) {
    return Sephora.configurationSettings.enableAddressValidation && (country === COUNTRIES.CA || country === COUNTRIES.US);
}

function formatZipPostalCode(inputData, divider, leftLength, totalLength) {
    let formatZipPostal = inputData;

    if (formatZipPostal) {
        if (formatZipPostal.length > leftLength && formatZipPostal.indexOf(divider) === -1) {
            // adds a hyphen/space if zip/postal code is missing one and needs it
            // calls autoFill function if zip/postal code after hyphen/space is 10/6 characters long
            formatZipPostal = `${formatZipPostal.slice(0, leftLength)}${divider}` + `${formatZipPostal.slice(leftLength, totalLength)}`;
        } else if (formatZipPostal.length === leftLength + 1) {
            // remove hyphen/space in zip/postal code if user removes the chars to right of divider
            if (formatZipPostal.slice(0, leftLength).indexOf(divider) !== -1) {
                formatZipPostal = formatZipPostal.replace(divider, '');
            }

            formatZipPostal = formatZipPostal.slice(0, leftLength);
        } else if (formatZipPostal.slice(0, leftLength).indexOf(divider) !== -1) {
            //remove hyphen/space if user deletes numbers in zip code well before hyphen/space
            formatZipPostal = formatZipPostal.replace(divider, '');

            if (formatZipPostal.length > leftLength) {
                formatZipPostal = `${formatZipPostal.slice(0, leftLength)}${divider}` + `${formatZipPostal.slice(leftLength, totalLength)}`;
            }
        }
    }

    return formatZipPostal;
}

// Removes the extra 4 digits of a zipcode
function formatZipCode(zip) {
    return (zip || '').split('-')[0];
}

/**
 * Compare two zip codes (handles ZIP+4 format)
 * @param {string} zip1 - First zip code
 * @param {string} zip2 - Second zip code
 * @returns {boolean} - True if base zip codes match
 * @example zipCodesMatch('14614', '14614-2020') returns true
 */
function zipCodesMatch(zip1, zip2) {
    if (!zip1 || !zip2) {
        return false;
    }

    // Extract base ZIP code (part before hyphen) for comparison
    // This handles ZIP+4 format where "14614" should match "14614-2020"
    const baseZip1 = formatZipCode(zip1);
    const baseZip2 = formatZipCode(zip2);

    return baseZip1 === baseZip2;
}

function updateLocalDefaultShippingAddressData(defaultSAData) {
    const { defaultSACountryCode, defaultSAZipCode } = defaultSAData;
    const userData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA) || Empty.Object;

    if (userData?.profile) {
        Object.assign(userData.profile, {
            defaultSACountryCode,
            defaultSAZipCode
        });

        Storage.local.setItem(LOCAL_STORAGE.USER_DATA, userData, UserUtils.USER_DATA_EXPIRY);
    }
}

const defaultsByCountry = {
    US: { preferredZipCode: '20147' },
    CA: { preferredZipCode: 'M5B 2H1' }
};

function getPreferredZipCodeOrDefault(preferredZipCode, options = Empty.Object) {
    const country = options.country || 'US';

    return preferredZipCode || defaultsByCountry[country].preferredZipCode;
}

export default {
    US_ZIP_CODE_FORMAT,
    hasAVS,
    formatZipPostalCode,
    formatZipCode,
    zipCodesMatch,
    updateLocalDefaultShippingAddressData,
    getPreferredZipCodeOrDefault
};
